/**
 * Set the NODE_ENV environment variable for the window object
 */
window.process = { env: { NODE_ENV: import.meta.env.MODE } };

/*************** */
/* Vue Directives   */
/*************** */
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';

/*************** */
/* Quasar        */
/*************** */
import { Quasar, Notify, Dialog, Loading } from 'quasar';
import { QTelInput } from '@tofandel/q-tel-input';
import quasarLang from 'quasar/lang/fr';

import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
import '@tofandel/q-tel-input/dist/style.css';

/*************** */
/* CSS           */
/*************** */
import './assets/css/main.css';

/*************** */
/* API           */
/*************** */
import { initAxiosRequestInterceptor } from './api/interceptors.js';
import { initAxiosRetry } from './api/retry.js';

/*************** */
/* Vue app       */
/*************** */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

const app = createApp(App);

/*************** */
/* Sentry        */
/*************** */
import Sentry from './services/Sentry.js';

Sentry.init(app);

/******************** */
/* App dependencies   */
/******************** */
app.use(Quasar, {
  lang: quasarLang,
  plugins: {
    Notify,
    Dialog,
    Loading,
  },
});
app.use(QTelInput);
app.use(autoAnimatePlugin);
app.use(createPinia());
app.use(router);

const $q = app.config.globalProperties.$q;
initAxiosRequestInterceptor({ router, $q });
initAxiosRetry();

app.mount('#app');

/*************** */
/* Realtime      */
/*************** */
import Realtime from './api/realtime';

void Realtime.connect();
